import { render, staticRenderFns } from "./ExamRandom.vue?vue&type=template&id=03c74063&"
import script from "./ExamRandom.vue?vue&type=script&lang=js&"
export * from "./ExamRandom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports